import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import {
  listingsSearchSchema,
  type ListingsSearch,
} from '~/features/catalog-enrichment/utils/run-products-search';

const RunListingsPage = lazy(() => import('~/features/catalog-enrichment/pages/run-listings-page'));

/** The Products tab's Listings view: every listing × step, with flag / clear and an id lookup. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/products/listings',
)({
  validateSearch: listingsSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  // Every filter, page and opened preview is a history entry, so Back steps through them.
  const onSearchChange = (patch: Partial<ListingsSearch>) => {
    void navigate({ search: (prev) => ({ ...prev, ...patch }) });
  };

  return (
    <Suspense fallback={<PageSkeleton />}>
      <RunListingsPage key={runId} runId={runId} search={search} onSearchChange={onSearchChange} />
    </Suspense>
  );
}
